import $fn from '@/utils/fn.ts';
import httpApi from '@/apis/httpApi'
import http from "@/utils/http.js"

// 登陆中手机验证码修改密码
interface ByPhoneLoginData {
    phone: string,
    code: string,
    newpassword: string,
    repassword: string
}
export const ByPhoneLogin = (json: ByPhoneLoginData): any => http.httpPost({
    url: httpApi.PassWord.ByPhoneLogin,
    json
})

export const ChangeByPhone = (json: ByPhoneLoginData): any => http.httpPost({
    url: httpApi.PassWord.changeByPhone,
    json
})
